import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import { throttle } from 'lodash';
import hoistNonReactStatics from 'hoist-non-react-statics';
import invariant from 'invariant';

const THROTTLE_TIME = 200;

/** Higher order component (HOC) that pass the component width as prop.
 *
 * class SomeComponent {
 *   static propTypes = {
 *     width: PropTypes.number.isRequired <- isRequired, can be use in the first render!
 *   }
 *
 *   render() {
 *     return <div>my width is {this.props.width} pixels</div>;
 *   }
 * }
 *
 * export default withWidth(SomeComponent);
 */

/* Placeholder is a component that we use to compute
 * the initial size of the children when mounted. We can't
 * just mount the child directly otherwise the width props
 * will be null at first and the child will have to re-render
 * when we'll set the width prop.
 */

class Placeholder extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,
  };

  render() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'className' does not exist on type 'Reado... Remove this comment to see the full error message
    const { className } = this.props;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'style' does not exist on type 'Readonly<... Remove this comment to see the full error message
    let { style } = this.props;

    if (!className && !style) {
      style = { width: '100%', height: '100%', position: 'relative' };
    }

    const props = { className, style };
    return <div {...props} />;
  }
}

// @ts-expect-error ts-migrate(7006) FIXME: Parameter 'Child' implicitly has an 'any' type.
export default function responsive(Child) {
  class WithWidth extends React.Component {
    static propTypes = {
      reference: PropTypes.func,
      className: PropTypes.string,
      style: PropTypes.object,
      ref: PropTypes.any,
    };

    state = {
      width: null,
    };

    displayName = `withWidth(${Child.displayName})`;

    componentDidMount() {
      invariant(
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'ref' does not exist on type 'Readonly<{}... Remove this comment to see the full error message
        !this.props.ref,
        'You cannot pass a ‘ref’ prop to withWidth HOC. Please pass ‘reference’ instead.'
      );
      window.addEventListener('resize', this.computeState);
      this.computeState();
    }

    componentWillUnmount() {
      window.removeEventListener('resize', this.computeState);
    }

    computeState = throttle(
      function () {
        // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
        this.node = ReactDOM.findDOMNode(this);
        // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
        if (!this.node) {
          return;
        }
        // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
        if (this.node.offsetWidth !== this.state.width) {
          // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
          this.setState({
            // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
            width: this.node.offsetWidth,
          });
        }
      }.bind(this),
      THROTTLE_TIME
    );

    render() {
      if (this.state.width !== null) {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'reference' does not exist on type 'Reado... Remove this comment to see the full error message
        return <Child {...this.state} {...this.props} ref={this.props.reference} />;
      } else {
        return <Placeholder />;
      }
    }
  }

  return hoistNonReactStatics(WithWidth, Child);
}
